import { log } from 'evlog/client';

import { MeetingRoom, useMeetingLoaderData } from '@virtual-care/ui';

export default function Meeting() {
  const { joinToken, reservation } = useMeetingLoaderData();
  log.info({
    action: 'meeting_join',
    reservationId: reservation.id,
    meetingId: joinToken.id,
  });
  return (
    <MeetingRoom
      navigationPath={`/appointment-review/${reservation.id}/${joinToken.id}`}
    />
  );
}
